import React from "react";
import { ArrowLeft } from "lucide-react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import { Button } from "../ui/button";
import StakeholderLanePage from "./StakeholderLanePage";
import OperatingHome from "./OperatingHome";
import StakeholderDetailDrawer from "./StakeholderDetailDrawer";
import StakeholderPersonPage from "./StakeholderPersonPage";
import StakeholderWeeklyReport from "./StakeholderWeeklyReport";
import { useStakeholderBoardState } from "./hooks/useStakeholderBoardState";

export default function StakeholderShell() {
  const navigate = useNavigate();
  const stakeholderState = useStakeholderBoardState();
  const { fetchRemoteState, items, selectedItem, setSelectedItemId, updateItem } = stakeholderState;
  const canOpenStakeholderPerson = (itemId) => {
    const item = items.find((entry) => entry.id === itemId);
    return !item?.disable_person_route_actions;
  };
  const openStakeholderPerson = (itemId) => {
    if (!canOpenStakeholderPerson(itemId)) return;
    navigate(`/community/person/${encodeURIComponent(itemId)}`);
  };
  const openStakeholderTimeline = (itemId) => {
    if (!canOpenStakeholderPerson(itemId)) return;
    navigate(`/community/person/${encodeURIComponent(itemId)}#contact-timeline`);
  };

  return (
    <div className="min-h-screen bg-slate-100 dark:bg-[#05080d]">
      <div className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/90 backdrop-blur dark:border-white/10 dark:bg-[#081018]/85">
        <div className="mx-auto flex max-w-[1800px] items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Dad Partners Community
            </p>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
              Separate relational lens. Current admin workbench remains intact underneath.
            </p>
          </div>

          <Button onClick={() => navigate("/")} variant="outline">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to current admin
          </Button>
        </div>
      </div>

      <Routes>
        <Route
          element={
            <OperatingHome
              {...stakeholderState}
              onOpenItem={openStakeholderPerson}
              onOpenTimeline={openStakeholderTimeline}
            />
          }
          index
        />
        <Route
          element={<StakeholderWeeklyReport board={stakeholderState.board} summary={stakeholderState.summary} />}
          path="weekly-report"
        />
        <Route
          element={<StakeholderLanePage board={stakeholderState.board} onOpenItem={openStakeholderPerson} />}
          path="lane/:laneId"
        />
        <Route
          element={
            <StakeholderPersonPage
              fetchRemoteState={fetchRemoteState}
              items={items}
              setSelectedItemId={setSelectedItemId}
              updateItem={updateItem}
            />
          }
          path="person/:itemId"
        />
        <Route element={<Navigate replace to="/community" />} path="*" />
      </Routes>

      <StakeholderDetailDrawer
        item={selectedItem}
        onClose={() => setSelectedItemId(null)}
        onSave={updateItem}
      />
    </div>
  );
}
